<script>

export default {
	props: {
		default_label: {
			type: String,
			required: false
		},
		value: {
			required: false
		},
		compact: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	methods: {
		click_Vse (evt) {
			this.allSelected = true;
			this.title = this.defaultItemLabel;
			this.$emit('input', null);
		},
		click_Item: function (item) {
			for (let _item of this.items) {
				_item.active = false;
			}
			item.active = true;
			this.title = item.label;
			this.allSelected = false;
			this.$emit('input', item.value);
		}
	},
	computed: {
		selectedTitle () {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		}
	},
	data: function () {
		return {
			title: 'Vse',
			defaultItemLabel: 'Vse',
			selectedValue: null,
			multiselect: false,
			allSelected: true,
			items: [
				{
					label: 'Proste',
					value: 0,
					active: false
				},
				{
					label: 'Zasedene',
					value: 1,
					active: false
				}
			]
		}
	},
	created () {
	}
}
</script>
<template>
	<b-dropdown :text="selectedTitle" ref="dropdown">
		<b-dropdown-item @click="click_Item(item)" v-for="item in items" :key="item.value" :active="item.active && !allSelected">
			{{ item.label }}
		</b-dropdown-item>
		<b-dropdown-divider></b-dropdown-divider>
		<b-dropdown-item @click="click_Vse" :active="allSelected">{{ defaultItemLabel }}</b-dropdown-item>
	</b-dropdown>
</template>
<style scoped>
.date-dd {
	width: 34rem!important;
}
.vc-border {
	border-width: 0!important;
}
.tools {
	padding-top: 12px;
	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 12px;
}
.smalldt button.btn {
	font-size: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/DropdownFilters/StatusHotelHrambaFilterDropdown.vue